import type { FetchFunction } from '#layers/base/public';
import type { WorkspaceEntityStore } from '#layers/runtime/entity-store/registry';
import { workspaceRuntime } from './runtime';

export interface WorkspaceRuntimeHandle {
	fetch: FetchFunction;
	isActive: () => boolean;
	run: <T>(operation: () => Promise<T>) => Promise<T>;
	signal: AbortSignal;
	slug: string;
	store: WorkspaceEntityStore;
}

/** Store of the active workspace runtime; throws before the first publication so nothing binds to a pending store. */
export function useWorkspaceEntityStore(): WorkspaceEntityStore {
	return useWorkspaceRuntimeHandle().store;
}

/** Captures one workspace's entities, transport, identity, and operation lifetime. */
export function useWorkspaceRuntimeHandle(): WorkspaceRuntimeHandle {
	const runtime = workspaceRuntime.activeRuntime.value;

	if (!runtime) {
		throw new Error('Workspace entity store is unavailable before a workspace runtime is published');
	}

	return {
		fetch: runtime.fetch,
		isActive: () => workspaceRuntime.activeRuntime.value === runtime,
		run: runtime.operations.run,
		signal: runtime.abortController.signal,
		slug: runtime.slug,
		store: runtime.store,
	};
}
